const enum Blockchain {
  Ethereum = 'ethereum',
  FirstOasisKlaytn = 'firstOasisKlaytn',
  Klaytn = 'klaytn',
  Counterparty = 'counterparty',
}

export default Blockchain;
